/* eslint-disable no-useless-escape */
import { Params } from '@angular/router'
export class StringUtils {
  public static toProperCase(str: string): string {
    return str
      .split(' ')
      .map((w) => w[0].toUpperCase() + w.substring(1).toLowerCase())
      .join(' ')
  }

  public static camelCaseToProperCase(str: string): string {
    return str
      .split('_')
      .map((w) => w[0].toUpperCase() + w.substring(1).toLowerCase())
      .join(' ')
  }

  public static hasQueryString(str: string): boolean {
    return !!(str || '').split('?')[1]
  }

  /**
   * Transform query string to JSON object
   * @param str e.g. 'price__lte=1000&category=adventure&category=experiences'
   */
  public static queryStringToJSON(str: string): object {
    const pairs = str.split('&')
    const result: Params = {}

    pairs.forEach((pair: string) => {
      const key = pair.split('=')[0]
      const value = pair.split('=')[1]
      if (key.length)
        if (result[key]) {
          if (!result[key].push) {
            result[key] = [result[key]]
          }
          result[key].push(value)
        } else {
          result[key] = value
        }
    })
    return result
  }

  public static isEmail(str: string): boolean {
    const emailRegex = /^.+\@.*$/
    return !!str.match(emailRegex)
  }

  /**
   * Returns true if the identity should be a phone number (not a valid phone), otherwise returns false
   * @param str
   */
  public static isPhoneNumber(str: string): boolean {
    const phoneRegex = /^[0-9\(\)\+\-\.x ]{6,}/
    return !!str.match(phoneRegex)
  }

  public static hyphenatePascalCase(str: string): string {
    return str.replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase()
  }

  public static isHtmlEmpty(str: string | undefined): boolean {
    if (!str) return true

    if (/<(?:img|iframe|video|embed)\b[^>]*>/i.test(str)) {
      return false
    }

    const text = str
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, '')
      .trim()

    return !text
  }
}
